module.exports = "/img/17.b19b58.webp";